import { BaseAPI } from "../../BaseAPI";
import * as environment from '../../../config/environment';

class AnketSorularAPI extends BaseAPI {


  constructor() {
    const baseUrl = environment.API_URL + "AnketSorularListe";
    super(baseUrl);
  }


  getAnketSorulariste(konuId?: number) {
    return this.get("", {params:{ konuId: konuId}});

  }

}
export default new AnketSorularAPI();
class AnketSorularListeRequest {
  public konuId?: number;
  constructor(konuId?: number) {

    this.konuId = konuId;

  }
}
export { AnketSorularListeRequest };